<template>
    <div class="c-visibility__wrapper t-margin-bottom-s" v-cloak>
		<template v-if="type === 'Process'">
			<div v-if="status === 'Unpublished'">
				<p>
					<span aria-hidden="true" class="c-icon c-icon--28px">
						<svg>
							<use xlink:href="#icon-closed-eye"></use>
						</svg>
					</span>
					Just nu ser bara du processen
				</p>
				<div class="c-visibility__action">
					<button type="submit" class="c-button c-button--reset c-button--linkstyle" @click="toggleStatusModal">Publicera process</button>
				</div>
			</div>
			<div v-if="status === 'Published'">
				<p>
					<span aria-hidden="true" class="c-icon c-icon--28px">
						<svg>
							<use xlink:href="#icon-open-eye"></use>
						</svg>
					</span>
					Just nu ser alla processen
				</p>
				<div class="c-visibility__action">
					<button type="submit" class="c-button c-button--reset c-button--linkstyle" @click="toggleStatusModal">Avpublicera process</button>
				</div>
			</div>
			<modal :show="showStatusModal" @closeModal="toggleStatusModal">
				<div class="c-modal__content t-background-white t-text-align-center">
					<template v-if="status === 'Unpublished'">
						<h1 class="t-text-style-alpha t-margin-bottom-s">Du publicerar nu process</h1>
						<button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleStatusModal">Avbryt</button>
						<button class="c-button c-button--primary" @click="toggle()">Publicera</button>
					</template>
					<template v-if="status === 'Published'">
						<h1 class="t-text-style-alpha t-margin-bottom-s">Du avpublicerar nu process</h1>
						<button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleStatusModal">Avbryt</button>
						<button class="c-button c-button--primary" @click="toggle()">Avpublicera</button>
					</template>
				</div>
			</modal>
		</template>
		<template v-if="type === 'process-step'">
			<div class="c-visibility__action" v-if="status === 'Unpublished'">
				<p>
					<span aria-hidden="true" class="c-icon c-icon--28px">
						<svg>
							<use xlink:href="#icon-closed-eye"></use>
						</svg>
					</span>
					Steget är dolt
				</p>
				<div class="c-visibility__action">
					<button type="submit" class="c-button c-button--reset c-button--linkstyle" @click="toggleVisibilityModal">Publicera steg</button>
				</div>
			</div>
			<div class="c-visibility__action" v-if="status === 'Published'">
				<p>
					<span aria-hidden="true" class="c-icon c-icon--28px">
						<svg>
							<use xlink:href="#icon-open-eye"></use>
						</svg>
					</span>
					Steget är publicerat
				</p>
				<div class="c-visibility__action">
					<button type="submit" class="c-button c-button--reset c-button--linkstyle" @click="toggleVisibilityModal">Avpublicera steg</button>
				</div>
			</div>
			<modal :show="showVisibilityModal" @closeModal="toggleVisibilityModal">
				<div class="c-modal__content t-background-white t-text-align-center">
					<template v-if="status === 'Unpublished'">
						<h1 class="t-text-style-alpha t-margin-bottom-s">Du publicerar nu steget</h1>
						<button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleVisibilityModal">Avbryt</button>
						<button class="c-button c-button--primary" @click="toggle()">Publicera</button>
					</template>
					<template v-if="status === 'Published'">
						<h1 class="t-text-style-alpha t-margin-bottom-s">Du avpublicerar nu steget</h1>
						<button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleVisibilityModal">Avbryt</button>
						<button class="c-button c-button--primary" @click="toggle()">Avpublicera</button>
					</template>
				</div>
			</modal>
		</template>
    </div>
</template>

<script>
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
export default {
	name: 'ToggleStatus',
	props: {
		status: String,
		processId: String,
		processStepId: String,
		type: String
	},
	components: {
		VueIcon,
		Modal
	},
	data() {
		return {
			showStatusModal: false,
			showVisibilityModal: false
		}
	},
	methods: {
	    toggle: function() {
			if (this.type === 'Process') {
				switch (this.status) {
					case 'Unpublished':
						this.$emit('publish', this.processId);
						this.toggleStatusModal();
						break;
					case 'Published':
						this.$emit('unpublish', this.processId);
						this.toggleStatusModal();
						break;
				}
			}
			if (this.type === 'process-step') {
				switch (this.status) {
					case 'Unpublished':
						this.$emit('publish', this.processStepId);
						this.toggleVisibilityModal();
						break;
					case 'Published':
						this.$emit('unpublish', this.processStepId);
						this.toggleVisibilityModal();
						break;
				}
			}
		},
		toggleStatusModal() {
			this.showStatusModal = !this.showStatusModal;
		},
		toggleVisibilityModal() {
			this.showVisibilityModal = !this.showVisibilityModal;
		}
	}
}
</script>